<template>
  <div class="space-y-2 sm:space-y-3">
    <button
      v-for="option in ratingOptions"
      :key="option.value"
      type="button"
      @click="selectRating(option.value)"
      :disabled="disabled"
      :class="[
        'w-full flex items-center gap-2 sm:gap-4 p-3 sm:p-4 rounded-xl border-2 transition-all text-left',
        selectedRating === option.value
          ? 'border-psychology-primary bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white shadow-lg'
          : disabled 
            ? 'border-gray-200 bg-white'
            : 'border-gray-200 hover:border-psychology-primary-20 hover:shadow-md bg-white',
        disabled ? 'cursor-not-allowed opacity-60' : ''
      ]"
    >
      <div
        :class="[
          'flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full font-bold text-base sm:text-lg flex-shrink-0',
          selectedRating === option.value
            ? 'bg-white text-psychology-primary'
            : 'bg-gray-100 text-gray-600'
        ]"
      >
        {{ option.value }}
      </div>
      <div class="flex-1">
        <div
          :class="[
            'font-medium text-sm sm:text-base',
            selectedRating === option.value ? 'text-white' : 'text-gray-900'
          ]"
        >
          {{ option.label }}
        </div>
      </div>
      <div v-if="selectedRating === option.value" class="flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-white sm:w-6 sm:h-6">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <path d="m9 11 3 3L22 4"></path>
        </svg>
      </div>
    </button>
  </div>
</template>

<script>
import { RATING_OPTIONS } from '@/data/aypQuestions'

export default {
  name: 'RatingButton',
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedRating: this.modelValue,
      ratingOptions: RATING_OPTIONS
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedRating = newVal
    }
  },
  methods: {
    selectRating(value) {
      if (this.disabled) return
      this.selectedRating = value
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

